export const SET_FETCHED_CLIENT = "SET_FETCHED_CLIENT";
export const RESET_STATE = "RESET_STATE";
export const SET_LOADING = "SET_LOADING";

export const setFetchedClient = (client) => ({
  type: SET_FETCHED_CLIENT,
  payload: client,
});
export const resetState = () => ({
  type: RESET_STATE,
});
export const setLoading = (isLoading = true) => ({
  type: SET_LOADING,
  payload: isLoading,
});